<template>
  <div class="xn-container" v-show="show">
    <!-- 方法一：通过css3的transition实现  -->
    <div class="css-popup">
      <div class="mask" @click="onclone(false)"></div>
      <div class="popup-content" ref="container" :class="{ show }">
        <div v-if="type == 1" class="list">
          <div class="list-top" @touchmove.prevent>
            <div class="list-top-bx">
              <div class="list-top-box">
                <img
                  v-if="tableIndex === 0"
                  class="btns_list-icon"
                  src="../../static/img/list-acitve.svg"
                  alt=""
                />
                <img
                  v-else
                  class="btns_list-icon"
                  src="../../static/img/home-list.svg"
                  alt=""
                />
                <span class="list-top-act" @click="tableChange(1)" key="1"
                  >景点<span>({{ lengthFn.spot }}处)</span></span
                >
                <div v-if="tableIndex === 0" class="btns_list-active"></div>
              </div>
              <div class="list-top-box" v-if="lengthFn.legend > 0">
                <img
                  v-if="tableIndex === 1"
                  class="btns_list-icon"
                  src="../../static/img/books-active.svg"
                  alt=""
                />
                <img
                  v-else
                  class="btns_list-icon"
                  src="../../static/img/books.svg"
                  alt=""
                />
                <span class="list-top-act" @click="tableChange(2)" key="2"
                  >故事<span>({{ lengthFn.legend }}个)</span></span
                >
                <div v-if="tableIndex === 1" class="btns_list-active"></div>
              </div>
            </div>
            <div class="list-top-rihg">
              <div @click="onClickCkeck" style="padding-left: 0.15rem">
                <ButtomCkeck
                  :defaultChecked="true"
                  :disabled="false"
                ></ButtomCkeck>
              </div>
              <span class="list-top-rihg_tit">连续播放</span>
            </div>
          </div>
          <div style="width: 100%; height: 1rem"></div>
          <div v-if="tableIndex === 0">
            <div
              class="list1"
              v-for="(item, index) in propslistFilter"
              :key="index"
            >
              <div @click="listen(index)" class="list-audio">
                <div v-if="showAdio == index">
                  <AudioPlayer
                    :key="index + 'ls'"
                    v-if="item.scenicsAudios && item.scenicsAudios.audioUrl"
                    :audioEndedEvent="() => audioEndedEvent()"
                    :viewName="item.viewName"
                    ref="AudioLss"
                    class="audio-box"
                    :audio_url="item.scenicsAudios.audioUrl"
                    :fetch-method="onclone"
                    :autopaly="autopaly"
                  ></AudioPlayer>
                </div>
                <div v-show="showAdio != index">
                  <span>{{ item.viewName }}</span>
                  <img src="../../static/img/pause1-voice.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="list1" v-for="(item, index) in legendList" :key="index">
              <div @click.stop="listen(index)" class="list-audio">
                <div v-if="showAdio == index">
                  <AudioPlayer
                    :key="index + 'ty'"
                    v-if="item.audioUrl"
                    :audioEndedEvent="() => audioEndedEvent()"
                    :viewName="item.viewName"
                    ref="AudioLss"
                    class="audio-box"
                    :audio_url="item.audioUrl"
                    :fetch-method="onclone"
                    :autopaly="autopaly"
                  ></AudioPlayer>
                </div>
                <div v-else>
                  <span>{{ item.viewName }}</span>
                  <img src="../../static/img/pause1-voice.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="type == 2" class="list2">
          <div class="title">景区介绍</div>
          <div style="width: 100%; height: 1rem"></div>
          <div class="list2-box">
            <div class="open-time">
              <span>{{ propslist[2].name }}</span>
              <span v-html="propslist[2].val"></span>
            </div>
            <div v-if="propslist.length > 5">
              <span class="url">{{ propslist[5].name }}</span>
              <span v-html="propslist[5].val"></span>
            </div>
            <div class="play-tiem">
              <span>{{ propslist[0].name }}</span>
              <span v-html="propslist[0].val"></span>
            </div>
            <div v-if="propslist.length > 3">
              <span class="car">{{ propslist[3].name }}</span>
              <span v-html="propslist[3].val"></span>
            </div>
            <div class="mare">
              <span>{{ propslist[1].name }}</span>
              <span v-html="propslist[1].val"></span>
            </div>
            <div v-if="propslist.length > 4">
              <span class="city">{{ propslist[4].name }}</span>
              <span v-html="propslist[4].val"></span>
            </div>
            <div class="tel" v-if="propslist.length > 6">
              <span>{{ propslist[6].name }}</span>
              <span v-html="propslist[6].val"></span>
            </div>
          </div>
        </div>
        <div class="clone" v-show="show">
          <img src="../../static/img/close.png" alt="" @click="onclone" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AudioPlayer from "./audioPlayer.vue";
import ButtomCkeck from "./buttomCkeck.vue";
export default {
  name: "Fixed",
  props: ["poplist", "scenicImgurl", "name", "uuid", "userId", "legendList"],
  data() {
    return {
      show: false,
      propslist: [],
      type: 1,
      showAdio: null,
      onClickCkeckState: true,
      tableIndex: 0,
      autopaly: false,
      state: false
    };
  },
  components: {
    AudioPlayer,
    ButtomCkeck
  },
  computed: {
    propslistFilter() {
      return this.propslist.filter(item => item.showType !== "tag");
    },
    lengthFn() {
      return {
        spot:
          this.propslist.filter(item => item.showType !== "tag").length || 0,
        legend: this.legendList.length || 0
      };
    }
  },
  methods: {
    tableChange(type) {
      if (type === 1) {
        this.tableIndex = 0;
        this.showAdio = null;
      } else {
        this.tableIndex = 1;
        this.showAdio = null;
      }
    },
    audioEndedEvent() {
      if (this.onClickCkeckState) {
        if (this.showAdio < this.propslist.length - 1) {
          this.showAdio = this.showAdio + 1;
          // this.autopaly = "autopaly";
          this.recordFn(this.showAdio, 1);
          setTimeout(() => {
            this.$nextTick(() => {
              if (this.$refs.AudioLss[0]) {
                // this.$refs.AudioLss[0].plays();
              }
            });
          }, 200);
        }
      }
    },
    showCssPopup(flag, arr, type) {
      this.show = flag;
      this.propslist = arr;
      this.type = type;
      this.$refs.container.scrollTop = 0;
    },
    onclone() {
      this.show = false;
      if (this.showAdio !== null) {
        this.$refs.AudioLss[0].onclone();
      }
    },
    recordFn(index, isAutoplay) {
      let obj = [
        {
          img: this.scenicImgurl,
          relationName: this.propslistFilter[index].viewName,
          name: this.name,
          uuid: this.uuid,
          userId: this.userId,
          type: 2,
          relationId: this.propslistFilter[index].viewId,
          isAutoplay,
          clickTime: new Date().getTime()
        }
      ];
      this.$http({
        url: "https://tumaomao.miaodonglvxing.com/travelwalkman/know/addRecord",
        method: "post",
        data: obj
      }).then(res => {
        console.log(res);
      });
    },
    onClickCkeck() {
      this.onClickCkeckState = !this.onClickCkeckState;
    },
    listen(index) {
      this.state = !this.state;
      if (this.showAdio != index) {
        this.recordFn(index, 0);
      }
      this.showAdio = index;
      // if (this.$parent.currentOrNextClick) {
      //   this.$parent.currentOrNextClick(this.propslistFilter, index, false);
      // }
      this.$nextTick(() => {
        if (this.$refs.AudioLss[0]) {
          this.$refs.AudioLss[0].plays();
          if (this.$refs.AudioLss[0].localVideo)
            this.$refs.AudioLss[0].localVideo.volume = 0;
        }
      });
      this.$parent.myAudio.pause();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.xn-container {
  height: 100%;
}
button {
  display: block;
  width: 300px;
  height: 44px;
  margin: 20px auto;
  border-radius: 4px;
  background-color: #3884ff;
  color: #fff;
}
.empty-state {
  font-size: 0.4rem;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.list-top {
  font-size: 0.3rem;
  display: flex;
  justify-content: space-between;
  height: 1rem;
  align-items: center;
  position: fixed;
  padding: 0 0.5rem;
  box-sizing: border-box;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  z-index: 999;
  .list-top-bx {
    display: flex;
    align-items: center;
  }
  .list-top-box {
    display: flex;
    align-items: center;
    margin-right: 0.4rem;
    position: relative;
    .btns_list-active {
      background: orangered;
      width: 50%;
      height: 2px;
      position: absolute;
      bottom: -7px;
      left: 0.5rem;
    }
  }
  .btns_list-icon {
    width: 0.4rem;
    height: 0.4rem;
  }
  .list-top-rihg {
    font-size: 0.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .list-top-rihg_tit {
      font-weight: bold;
      margin-top: 0.1rem;
    }
  }
  .list-top-act {
    font-size: 0.35rem;
    font-weight: bold;
    margin-left: 0.08rem;
    > span {
      font-size: 0.2rem;
    }
  }
}
.css-popup {
  height: 100%;
  .popup-content {
    position: absolute;
    height: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    -webkit-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;
    height: auto;
    &.show {
      max-height: 65%;
      min-height: 50%;
      overflow: auto;
    }
    p {
      line-height: 30px;
      text-align: center;
    }
    .list {
      padding-bottom: 1rem;
      position: relative;
      height: auto;
    }
    .list1 {
      padding: 0 0.5rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .list-audio {
        flex: 1;
        div {
          display: flex;
          font-size: 0.3rem;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          line-height: 1.2rem;
          > img {
            width: 0.7rem;
            height: 0.7rem;
          }
        }
      }
    }
    .list2 {
      font-size: 0.28rem;
      height: auto;
      .list2-box {
        padding: 0 0.5rem 1rem 0.5rem;
        box-sizing: border-box;
        > div {
          display: flex;
          margin-top: 0.5rem;
          :nth-child(1) {
            margin-right: 0.3rem;
            width: auto;
          }
          :nth-child(2) {
            flex: 1;
            min-width: 0;
          }
        }
      }
      .title {
        height: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.3rem;
        position: fixed;
        width: 100%;
        left: 0;
        background: rgba(255, 255, 255, 0.9);
      }
    }
    .clone {
      position: fixed;
      bottom: 0;
      width: 100%;
      background: rgba(255, 255, 255, 0.9);
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      > img {
        width: 0.47rem;
        height: 0.47rem;
      }
    }
  }
}

.mask {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease-in;
}

.slide-enter-active {
  animation-name: slideInUp;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slide-leave-active {
  animation-name: slideOutDown;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
@keyframes slideInUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translateZ(0);
  }
}
@keyframes slideOutDown {
  0% {
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}
.delay-leave-active {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -o-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/pop-up.vue